export default "__VITE_ASSET__c0f6af0b__"